import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import type { AuditLogsServiceInterface, GetAuditLogsPropsInterface } from '@src/server';
import { AuditLogsAndCursorInterface } from '@src/domain/types';
import { AuditLogsApi, AuditLogsResponse } from 'cmp-client-api';

export class AuditLogsService implements AuditLogsServiceInterface {
  private readonly service: AuditLogsApi;

  private readonly serviceMapper: MapperInterface<AuditLogsAndCursorInterface, AuditLogsResponse>;

  public constructor(
    service: AuditLogsApi,
    serviceMapper: MapperInterface<AuditLogsAndCursorInterface, AuditLogsResponse>
  ) {
    this.service = service;
    this.serviceMapper = serviceMapper;
  }

  public getAuditLogs(filter?: GetAuditLogsPropsInterface): Promise<AuditLogsAndCursorInterface> {
    return this.service
      .getAuditLogs(filter?.type, filter?.limit, filter?.after)
      .then(({ data }) => data)
      .then(this.serviceMapper.transformFromApiModel);
  }
}
